import React from 'react';
import { PricingCard } from './PricingCard';
import { PRICING_SECTION_ID } from '../utils/scroll';
export function Pricing() {
  return <section id={PRICING_SECTION_ID} className="scroll-mt-4 bg-slate-50 px-5 py-16 sm:py-20" data-id="element-150" data-mp="2aqsux5649bob">
      <div className="mx-auto max-w-3xl" data-id="element-151" data-mp="2oktn1g2kc0fp">
        <div className="text-center" data-id="element-152" data-mp="2jj4b7y7iniqk">
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-gold-dark" data-id="element-153" data-mp="2jk5wevi8xlm0">
            🔥 Launch Price
          </p>
          <h2 className="mt-3 font-display text-3xl font-black leading-tight text-navy-800 sm:text-4xl" data-id="element-154" data-mp="1vvv1sa358i66">
            Everything included,{' '}
            <span className="text-gold-dark" data-id="element-155" data-mp="25shkas7zyx51">one single price.</span>
          </h2>
          <p className="mt-3 text-sm text-slate-600" data-id="element-156" data-mp="20sljf1uljltp">
            Complete package. No upsells. No surprises.
          </p>
        </div>

        <div className="mt-10" data-id="element-157" data-mp="3h5thwld5yjir">
          <PricingCard data-id="element-158" data-mp="3h97n01d7p6tw" />
        </div>
      </div>
    </section>;
}